#import "../fragments/account-type-automation-fragment.graphql"

query GetAccountAssignmentAutomation($automationId: ID!) {
    accountTypeAutomation(id: $automationId) {
        ...AccountTypeAutomation
    }
}
